module.exports = __webpack_public_path__ + "img/Dash_mini_email.c060e2b6.svg";